<template>
  <div class="article-header-wrapper">
    <div class="container article-header">
      <node-label :node="node"></node-label>
      <div class="article-title" v-if="title">{{title}}</div>
      <field-subheading :subheading="node.subheading"></field-subheading>
    </div>
  </div>
</template>

<script>
  import get from 'lodash/get'
  import NodeLabel from 'components/node/Label.vue'
  import FieldSubheading from 'components/node/fields/Subheading.vue'

  export default {
    name: 'article-header',
    components: {
      NodeLabel,
      FieldSubheading,
    },
    props: ['node'],
    computed: {
      title() {
        if (get(this, 'node.default_head')) {
          return get(this, 'node.default_head')
        }
        return get(this, 'node.title', '')
      },
    },
  }
</script>

<style scoped lang="scss">
  .article-header-wrapper {
    background: $black;
  }

  .article-header {
    padding-bottom: rem-calc(57);
    padding-top: rem-calc(66);
    font-family: $barlow;
    @include respond-to('mobile') {
      padding-left: rem-calc($mobile-article-gutter);
      padding-right: rem-calc($mobile-article-gutter);
    }
    /deep/ .node-label {
      color: $banana-yellow;
      text-transform: uppercase;
      @include respond-to('mobile') {
        font-size: rem-calc(16);
        line-height: rem-calc(20);
        font-weight: bold;
      }
      .fields, .icon-wrapper {
        display: inline-block;
      }
      .icon-wrapper--photo {
        @include respond-to('mobile') {
          position: relative;
          top: rem-calc(-1);
        }
      }
    }
  }

  .article-title {
    font-family: $barlow;
    font-size: rem-calc(34);
    color: $white;
    font-weight: bold;
    line-height: rem-calc(40);
  }
</style>



// WEBPACK FOOTER //
// ArticleHeader.vue?7af4e889